import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, map } from 'rxjs';
import { ContactVariables } from '../models';

// Support contact details per market. They are text keys in translation-service, edited in tutoring-admin under
// Localization; until 2026-10 they came from bah-api GET /api/admin/contactVariables.
const CONTACT_KEYS: Record<keyof ContactVariables, string> = {
  contactEmail: 'texts.ContactInfo_email',
  contactPhoneDisplayed: 'texts.ContactInfo_phone_displayed',
  contactPhoneLinked: 'texts.ContactInfo_phone_linked',
  contactTimeOpen: 'texts.ContactInfo_time_open',
  contactTimeClose: 'texts.ContactInfo_time_close',
  contactWhatsapp: 'texts.ContactInfo_whatsapp',
  contactWhatsappLink: 'texts.ContactInfo_whatsapp_link',
};

@Injectable({
  providedIn: 'root'
})
export class VariableService {

  contactVariable$!: Promise<ContactVariables>;

  constructor(
    private translate: TranslateService,
  ) {
    this.setContactVariables();
  }

  setContactVariables(): void {
    this.contactVariable$ = firstValueFrom(this.translate.get(Object.values(CONTACT_KEYS)).pipe(
      map((texts: Record<string, string>) => {
        const variables = new ContactVariables({});
        for (const field of Object.keys(CONTACT_KEYS) as Array<keyof ContactVariables>) {
          const key = CONTACT_KEYS[field];
          // a key missing in translation-service comes back as the key itself
          variables[field] = texts[key] && texts[key] !== key ? texts[key] : undefined;
        }
        return variables;
      }),
    ));
  }

}
